
import { defineComponent } from "vue";
import InlineSvg from "vue-inline-svg";
import {
  BIconCalendarFill,
  BIconHourglassSplit,
  BIconPeopleFill,
} from "bootstrap-icons-vue";
import { CSidebar } from "@coreui/vue";

export default defineComponent({
  name: "AppSidebar",
  components: {
    InlineSvg,
    BIconCalendarFill,
    BIconHourglassSplit,
    BIconPeopleFill,
    CSidebar,
  },
  computed: {
    sidebarUnfoldable() {
      return this.$store.state.theme.sidebarUnfoldable;
    },
    sidebarVisible() {
      return this.$store.state.theme.sidebarVisible;
    },
  },
});
